$(document).on('click', '.product-quick-add-swatch .swatch-element', function(e){
  e.preventDefault();
  e.stopPropagation();
  var image = $(this).data('image');
  var value = $(this).data('value');
  var variant = $(this).data('variant');
  var $container = $(this).parents('.product-quick-add-container');
  $container.find('.js-swatch-current-selection').text(value);
  $container.find('#product-quick-add-image').attr('src', image);
  $container.find('.product-quick-add-popup-atc.js-product-quick-add').data('id', variant);
})

$(document).on("click", ".js-open-qa", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $qv = $(".product-quick-add-popup");
  var handle = $(this).data("handle");
  var variant = $(this).data('variant');
  var url = "/products/" + handle + "?view=quick-add"; 
  
  console.log('Quick Add clicked - Handle:', handle, 'Variant:', variant);

  if(variant){
    url += "&variant=" + variant;
    console.log('Quick Add URL with variant:', url);
  } else {
    console.log('Quick Add URL without variant:', url);
  }
  
  $.ajax({
    type: "GET",
    url: url,
    success: function (html) {
      console.log('Quick Add popup content loaded');
      $qv.find(".product-quick-add-popup-content").html(html);
      
      // If a variant was passed, find the corresponding swatch and activate it
      if (variant) {
        console.log('Looking for variant swatch:', variant);
        var $variantSwatch = $qv.find('.js-quick-add-swatch-item[data-id="' + variant + '"]');
        console.log('Variant swatch found:', $variantSwatch.length);
        
        if ($variantSwatch.length) {
          // Remove active class from all swatches
          $qv.find('.js-quick-add-swatch-item').removeClass('active');
          // Add active class to the selected variant swatch
          $variantSwatch.addClass('active');
          // Trigger click to update image, price, etc.
          $variantSwatch.trigger('click');
          console.log('Activated variant swatch:', variant);
        }
      } else {
        // find the already active swatch and set image, price, etc.
        var $activeSwatch = $qv.find('.js-quick-add-swatch-item.active');
        console.log('Active swatches found in popup:', $activeSwatch.length);
        if ($activeSwatch.length) {
          console.log('Triggering click on active swatch');
          $activeSwatch.trigger('click');
        }
      }

      $("html, body").addClass("qa--open");
      window.addEventListener("click",handleClickOutsideQA);
      $qv.addClass("open");
    },
    error: function () {
      window.location.href = $(this).attr("href");
    },
  });
});

$(document).on('click', '.js-product-quick-add-popup-close', function(e){
  quickAddPopupClose();
})

$(document).on('click', '.js-product-quick-add', function(e){
  console.log('quick add 2')
  var $this = $(this);
  $this.prop('disabled', true);
  
  // Close popup instantly - Rebuy Smart Cart opens immediately via Rebuy.Cart.addItem
  quickAddPopupClose();
  window.removeEventListener("click",handleClickOutsideQA);
  
  // Re-enable button after short delay
  setTimeout(function(){
    $this.prop('disabled', false);
  }, 300);
})

function quickAddPopupClose(){
  $("html, body").removeClass("qa--open");
  var $qv = $(".product-quick-add-popup");
  $qv.removeClass('open');
}

function handleClickOutsideQA(e){
  if (
    !$(e.target).is(".product-quick-add-popup-content-wrapper *") &&
    $("html").hasClass("qa--open")
  ) {
    quickAddPopupClose();
  }
}